import gql from 'graphql-tag';
const query = gql`
	query getLaCount($hostErasmusCode: String,$homeErasmusCode: String,$academicYear:String){
	    laCount(hostErasmusCode:$hostErasmusCode,homeErasmusCode:$homeErasmusCode,academicYear:$academicYear)
	
	}
`;
export { query };